import { Container } from '../../components/Container'
import { Text } from '../../components/Text'
import { useI18n } from '../../i18n'

/**
 * "Contact us" card: heading + supportive copy. The Message Us button stays out
 * until it has a real destination — a control that does nothing reads as broken.
 */
export function ContactCard() {
  const { t } = useI18n()

  return (
    <Container className="p-6">
      <Text as="h2" variant="h3" weight="bold" className="text-gray-900">
        {t('home.contact.title')}
      </Text>
      <Text as="p" variant="base" className="mt-2 text-gray-700">
        {t('home.contact.body')}
      </Text>
    </Container>
  )
}
